// Dynamic Sitemap Generator for Workbrook
// This utility generates a sitemap including all job postings

export const generateDynamicSitemap = async (jobs) => {
  const baseUrl = process.env.REACT_APP_WEB_URL || 'https://workbrook.com';
  const currentDate = new Date().toISOString().split('T')[0];
  
  const staticPages = [
    { url: '/', priority: '1.0', changefreq: 'daily' },
    { url: '/jobs', priority: '0.9', changefreq: 'daily' },
    { url: '/careers', priority: '0.9', changefreq: 'daily' },
    { url: '/google-jobs', priority: '0.9', changefreq: 'daily' },
    { url: '/signin', priority: '0.8', changefreq: 'weekly' },
    { url: '/signup', priority: '0.8', changefreq: 'weekly' },
  ];
  
  let sitemap = `<?xml version="1.0" encoding="UTF-8"?>
<urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9">`;

  // Add static pages
  staticPages.forEach(page => {
    sitemap += `
  <url>
    <loc>${baseUrl}${page.url}</loc>
    <lastmod>${currentDate}</lastmod>
    <changefreq>${page.changefreq}</changefreq>
    <priority>${page.priority}</priority>
  </url>`;
  });

  // Add job detail pages
  if (jobs && jobs.length > 0) {
    jobs.forEach(job => {
      const jobDate = job.date_created ? new Date(job.date_created).toISOString().split('T')[0] : currentDate;
      sitemap += `
  <url>
    <loc>${baseUrl}/job-lists-details/${job.id}/apply/no-ref</loc>
    <lastmod>${jobDate}</lastmod>
    <changefreq>weekly</changefreq>
    <priority>0.7</priority>
  </url>`;
    });
  }

  sitemap += `
</urlset>`;

  return sitemap;
};

// Function to download sitemap as file
export const downloadSitemap = (sitemapContent) => {
  const blob = new Blob([sitemapContent], { type: 'application/xml' });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = 'sitemap.xml';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
};

// Function to generate a URL list for Google Search Console
export const generateUrlList = (jobs) => {
  const baseUrl = process.env.REACT_APP_WEB_URL || 'https://workbrook.com';
  
  const urls = [
    `${baseUrl}/jobs`,
    `${baseUrl}/careers`,
    `${baseUrl}/google-jobs`
  ];
  
  if (jobs && jobs.length > 0) {
    jobs.forEach(job => {
      urls.push(`${baseUrl}/job-lists-details/${job.id}/apply/no-ref`);
    });
  }
  
  return urls;
};

// Function to copy URL list to clipboard
export const copyUrlsToClipboard = (jobs) => {
  const urls = generateUrlList(jobs);
  const urlText = urls.join('\n');
  
  navigator.clipboard.writeText(urlText).then(() => {
    console.log('URLs copied to clipboard');
    return true;
  }).catch(err => {
    console.error('Failed to copy URLs: ', err);
    return false;
  });
}; 